module.exports = __webpack_public_path__ + "fonts/HalisR-S-Book.efa7c334.otf";